module.exports = __webpack_public_path__ + "img/1480041337.22fc0a72.jpg";